import {Vue} from '~/addiesaas'
import _ from 'lodash'
import axios from "./axios"
import {renderConfigs} from './config'

const config = window.addiesaas.config

async function performActions(rule, eventBus, args, display) {
    display.upsellValue = 0
    display.revertCallbacks = []

    for (const action of rule.actions.data) {
        const payload = {}
        await eventBus.$$emitAsync(`cart-rule-action:${action.type}`, action, args, display.id, payload)
        if (payload.upsell_value) {
            display.upsellValue += payload.upsell_value
        }
        if (payload.revertCallback) {
            display.revertCallbacks.push(payload.revertCallback)
        }
    }

    if (display.upsellValue) {
        await axios.post(`${config.apiUri}/customer/cart-rule/${rule.id}/display/${display.id}/upsell`, {
            value: display.upsellValue,
        })
    }
}

async function revertActions(rule, eventBus, args, display) {
    for (const revert of display.revertCallbacks) {
        revert()
    }
    display.revertCallbacks = []

    if (display.upsellValue) {
        await axios.post(`${config.apiUri}/customer/cart-rule/${rule.id}/display/${display.id}/upsell`, {
            value: null,
        })
        display.upsellValue = 0
    }
}

function isNotificationLocationAvailable(type, location) {
    switch (type) {
        case 'modal':
        case 'bar':
            return !location || window.location.pathname.match(location)
        case 'placeholder':
            return !!document.getElementById(`reContentPlaceholder_${location}`)
    }
}

function validateNotificationFrequency(rule) {
    const store = window.addiesaas.store

    const authUser = store.getters['authUser']
    const userId = authUser ? authUser.id : null

    const displays = store.getters['Marketing/CartRules/Log/displays']
        .filter(display => display.ruleId == rule.id && display.userId == userId)
    const sessions = Object.values(store.getters['Marketing/CartRules/Log/sessions'])
        .filter(session => session.userId == userId)

    const confirmationOptions = rule.confirmation_options
    const {
        max_number_of_displays: maxNumberOfDisplays,
        notification_frequency: notificationFrequency,
        notification_frequency_sessions: frequencySessions,
        notification_frequency_time_frequency: frequencyTime,
    } = confirmationOptions

    if (maxNumberOfDisplays && maxNumberOfDisplays <= displays.length) {
        return false
    }

    if (notificationFrequency == 'sessions' && frequencySessions && displays.length) {
        const lastDisplay = displays[displays.length - 1]
        const lastDisplaySessionId = lastDisplay.sessionId
        const lastDisplaySession = sessions.find(session => session.id == lastDisplaySessionId)

        if (lastDisplaySession) {
            const sessionsAfterLastDisplay = sessions.filter(session => session.start > lastDisplaySession.start)

            if (sessionsAfterLastDisplay.length < frequencySessions) {
                return false
            }
        }
    }

    if (notificationFrequency == 'time_frequency') {
        const date = new Date()
        date.setDate(date.getDate() - frequencyTime.days)
        const dateJSON = date.toJSON()

        const displaysDuringLastDays = displays.filter(display => display.date > dateJSON)

        if (displaysDuringLastDays.length >= frequencyTime.times) {
            return false
        }
    }

    return true
}

function showConfirmation(rule, queued, eventBus, args, display) {
    if (!window.addiesaas.cart_rules.componentCalls) {
        window.addiesaas.cart_rules.componentCalls = {}
    }

    const id = rule.id

    let container = document.createElement('div')
    container.id = `addiesaasCartRulesConfirmationContainer_${id}`

    const existingNode = document.getElementById(container.id)
    if (existingNode) {
        existingNode.parentNode.removeChild(existingNode)
    }

    window.addiesaas.cart_rules.componentCalls[id] = {
        id,
        rule,
        queued,
        accept: () => {
            acceptDisplay(rule.id, display)
            performActions(rule, eventBus, args, display)
        },
        dismiss: () => {
            dequeue(rule)
            const node = document.getElementById(container.id)
            node.parentNode.removeChild(node)
        },
        revert: () => {
            revertActions(rule, eventBus, args, display)
            declineDisplay(rule.id, display)
        },
    }

    const confirmationOptions = rule.confirmation_options || {}
    const type = confirmationOptions.event_notification_type

    const config = renderConfigs[type]
    if (config) {
        const location = confirmationOptions.notification_location
        const target = location ?
            document.getElementById(`reContentPlaceholder_${location}`) :
            document.body
        target.appendChild(container)

        const component = confirmationOptions.custom_component || config.render.component
        const options = config.render.options || {}

        embedConfirmation(container, id, component, options)

        const containerOptions = config.container || {}
        for (let property in containerOptions) {
            const value = containerOptions[property]
            if (property === 'style') {
                for (let styleName in value) {
                    const styleValue = value[styleName]
                    container.style[styleName] = styleValue
                }
            } else {
                container[property] = value
            }
        }
        _.forOwn(containerOptions, (value, property) => {
            if (property === 'style') {
                _.forOwn(value, (styleValue, styleName) => {
                    container.style[styleName] = styleValue
                })
            } else {
                container[property] = value
            }
        })
    }
}

function embedConfirmation(container, callId, component, options = {}) {
    options = _.merge({
            strict: false,
            preloader: false,
            classes: false
        },
        options || {},
        {
            component: {
                attributes: {callId}
            }
        }
    )

    if (typeof window.$$re === 'undefined') {
        addiesaas.render(component, `#${container.id}`, options)
    } else {
        $$re('add', component, `#${container.id}`, options)
    }

    return container
}

async function logDisplay(rule, options = {}) {
    window.addiesaas.store.dispatch('Marketing/CartRules/Log/logDisplay', { ruleId: rule.id })

    const { data: { data: display } } = await axios.post(`${config.apiUri}/customer/cart-rule/${rule.id}/display`, Object.assign({
        session_id: window.addiesaas.store.getters['Marketing/CartRules/Session/session'],
    }, options))

    return display
}

function enqueue(rule, args) {
    args = _.omitBy(args, i => i instanceof Vue)
    return window.addiesaas.store.dispatch('Marketing/CartRules/Session/enqueue', { rule, args })
}

function dequeue(rule) {
    window.addiesaas.store.dispatch('Marketing/CartRules/Session/dequeue', { id: rule.id })
}

function displayTimer(queued, displayEnding) {
    window.addiesaas.store.dispatch('Marketing/CartRules/Session/displayTimer', { id: queued.rule.id, displayEnding })
}

function rememberDisplay(ruleId, display) {
    window.addiesaas.store.dispatch('Marketing/CartRules/Session/rememberDisplay', { id: ruleId, display })
}

async function acceptDisplay(ruleId, display) {
    const { data: { data: newDisplay } } = await axios.post(`${config.apiUri}/customer/cart-rule/${ruleId}/display/${display.id}/accept`)
    rememberDisplay(ruleId, newDisplay)
    return display
}

async function declineDisplay(ruleId, display) {
    const { data: { data: newDisplay } } = await axios.post(`${config.apiUri}/customer/cart-rule/${ruleId}/display/${display.id}/decline`)
    rememberDisplay(ruleId, newDisplay)
    return display
}

export default async function (rule, eventBus, queued, args) {
    if (rule.confirmation_type == 'offer') {
        const notificationType = rule.confirmation_options.event_notification_type
        const notificationLocation = rule.confirmation_options.notification_location

        if (isNotificationLocationAvailable(notificationType, notificationLocation)) {
            if (validateNotificationFrequency(rule)) {
                if (rule.confirmation_options.countdown_seconds) {
                    if (!queued) {
                        queued = await enqueue(rule, args)
                    }

                    if (queued.displayEnding) {
                        if (queued.displayEnding < (new Date()).toJSON()) {
                            dequeue(rule)
                            return
                        }
                    } else {
                        const displayEnding = (new Date((new Date()).getTime() + rule.confirmation_options.countdown_seconds * 1000)).toJSON()
                        displayTimer(queued, displayEnding)
                    }

                    if (rule.confirmation_options.countdown_temporary) {
                        dequeue(rule)
                    }
                }

                let display
                if (queued.display) {
                    display = queued.display
                } else {
                    display = await logDisplay(rule)
                    rememberDisplay(rule.id, display)
                }

                showConfirmation(rule, queued, eventBus, args, display)
            } else {
                dequeue(rule)
            }
        } else {
            if (!queued) {
                enqueue(rule, args)
            }
        }
    } else {
        const display = await logDisplay(rule, { accepted: true })
        await performActions(rule, eventBus, args, display)
    }
}
